import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UserService, ContextService, CommandeService, CartService } from '../../shared';
import { User, EnteteCommande, Panier } from '../../shared';
import * as html2c from 'html2canvas';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {

  @ViewChild('cgv') check;

  context: string;
  context_route: string;
  currentUser: User;
  commande: EnteteCommande;
  req: any = {};
  errorMessage: string = "";
  panier: Panier;
  panierLoaded: boolean = false;

  constructor(
  	private userService: UserService,
    private contextService: ContextService,
    private cartService: CartService,
    private commandeService: CommandeService,
    private router: Router,
  ) {}

  ngOnInit() {

    this.context = this.contextService.getContext();
    this.context_route = (this.context == 'B2C') ? '/familles' : '';
    this.userService.currentUser.subscribe(
      data => {
        this.currentUser = data;
      }
    );

    this.cartService.getUserCart().subscribe(
      panier => {
        this.panier = panier;
        this.panierLoaded = true;
      }
    );

    let fac = JSON.parse(sessionStorage.getItem("fac_hachette_kne"));
    let liv = JSON.parse(sessionStorage.getItem("liv_hachette_kne"));
    // sessionStorage.removeItem("fac_hachette_kne");
    // sessionStorage.removeItem("liv_hachette_kne");

    let preuves = JSON.parse(sessionStorage.getItem('preuveachat_kne'));

    let body: any = {};
    body.adresseFacturation = {}; 
    body.adresseLivraison = {};
    body.preuvesAchat = preuves.preuvesAchat;
    body.preuvesAchatPapier = preuves.preuvesAchatPapier;
    body.adresseLivraison.email = liv.email;

    if(this.context == 'B2B'){
      if(this.currentUser.typeUtilisateur == 302){
        body.adresseFacturation.adresse1 = fac.adresse1;
        body.adresseFacturation.adresse2 = fac.adresse2;
        body.adresseFacturation.ville = fac.ville;
        body.adresseFacturation.idPaysLPC = +fac.idPaysLPC;
        body.adresseFacturation.codePostal = fac.codePostalEt;
        body.adresseLivraison.adresse1 = liv.adresseEt;
        body.adresseLivraison.adresse2 = liv.adresse2Et;
        body.adresseLivraison.ville = liv.villeEt;
        body.adresseLivraison.idPaysLPC = +liv.paysEt;
        body.adresseLivraison.codePostal = liv.codePostal;
      } else {
        body.adresseFacturation.adresse1 = fac.adresseEt;
        body.adresseFacturation.adresse2 = fac.adresse2Et;
        body.adresseFacturation.ville = fac.villeEt;
        body.adresseFacturation.idPaysLPC = +fac.paysEt;
        body.adresseFacturation.codePostal = fac.codePostalEt;
        body.adresseLivraison.adresse1 = liv.adresse1;
        body.adresseLivraison.adresse2 = liv.adresse2;
        body.adresseLivraison.ville = liv.ville;
        body.adresseLivraison.idPaysLPC = +liv.idPaysLPC;
        body.adresseLivraison.codePostal = liv.codePostal;
      }
    } else {
      body.adresseFacturation.adresse1 = fac.adresse1;
      body.adresseFacturation.adresse2 = fac.adresse2;
      body.adresseFacturation.ville = fac.ville;
      body.adresseFacturation.idPaysLPC = +fac.idPaysLPC;
      body.adresseFacturation.codePostal = fac.codePostal;
      body.adresseLivraison.adresse1 = fac.adresse1;
      body.adresseLivraison.adresse2 = fac.adresse2;
      body.adresseLivraison.ville = fac.ville;
      body.adresseLivraison.idPaysLPC = +fac.idPaysLPC;
      body.adresseLivraison.codePostal = fac.codePostal;
    }

    console.log(body);
    this.commandeService.validateCart(body).subscribe(
      data => {
        console.log(data)
        this.commande = data;
        this.req.codeKNE = data.codeKNE;
        sessionStorage.setItem("commande_hachette_kne", JSON.stringify(data));
      },
      error =>{
          alert(error[0].Message);
      }
    );

  }

  downloadCGV(){
    let el = document.getElementById('cgv-pdf');

    html2c(el).then( canvas => {
      console.log(canvas);
      var data = canvas.toDataURL();
      var docDefinition = {
        content: [
          {
            image: data,
            width: 510
          }
        ]
      };
      pdfMake.createPdf(docDefinition).download('cgv.pdf');
    });
  }

  goToConfirm(idModeReglement: number){
    this.errorMessage = '';
    if(!this.check.nativeElement.checked){
      this.errorMessage = 'Veuillez d\'abord accepter nos conditions générales de vente';
      return;
    }

    this.req.idModeReglement = idModeReglement;
    let temp: any;
    this.commandeService.payCart({codeKNE: this.commande.codeKNE, idModeReglement: 2}).subscribe(
      data => temp = data,
      error => console.log(error),
      () => {
         sessionStorage.setItem("commande_hachette_kne", JSON.stringify(temp));
      }
    );

    this.cartService.cartevent.emit('cartchange');

    if(this.context == 'B2B'){
      this.router.navigate(['/confirmation']);
    } else {
      this.router.navigate(['/familles/confirmation']);
    }
  }

  goToPayBox(){
    this.errorMessage = '';
    if(!this.check.nativeElement.checked){
      this.errorMessage = 'Veuillez d\'abord accepter nos conditions générales de vente';
      return;
    }

    this.req.idModeReglement = 3;
    let temp: any;
    this.commandeService.payCart({codeKNE: this.commande.codeKNE, idModeReglement: 3}).subscribe(
      data => {
        // console.log(data.payboxHTML)
        //   if(data.payboxHTML){
        //         document.write(data.payboxHTML.replace("\\", ""));
        //          setTimeout('document.PAYBOX.submit()',1000)
        //          this.cartService.cartevent.emit('cartchange');
        //   }
        if(data.actionPaybox){
          this.sendPayboxForm(data.formPaybox, data.actionPaybox);
          this.cartService.cartevent.emit('cartchange');
        }



      },
      error => alert(error.Message),
      () => {
        sessionStorage.setItem("commande_hachette_kne", JSON.stringify(temp));
      }
    );

    // let paybox = this.commande.payboxHTML;
    /*if(this.context == 'B2B'){
      this.router.navigate(['/confirmation']);
    } else {
      this.router.navigate(['/familles/confirmation']);
    }*/
  }

  onCheck(){
    if(this.panier.montantTotal == 0 && this.check.nativeElement.checked){
     //if(this.context == 'B2B'){
       this.commandeService.payCart({codeKNE: this.commande.codeKNE, idModeReglement: 5}).subscribe(
            data => {
         
                this.router.navigate(['/confirmation']);
            },
            error => alert(error.Message)
          );
      //} 
    }
  }

  sendPayboxForm(formData: any, link: string){
    document.write('<form class="hide" id="pbxForm" action="' + link + '" method="POST">');
    document.write('<input type="hidden" name="PBX_ANNULE" value="' + formData.PBX_ANNULE + '">');
    document.write('<input type="hidden" name="PBX_EFFECTUE" value="' + formData.PBX_EFFECTUE + '">');
    document.write('<input type="hidden" name="PBX_REFUSE" value="' + formData.PBX_REFUSE + '">');
    document.write('<input type="hidden" name="PBX_SITE" value="' + formData.PBX_SITE + '">');
    document.write('<input type="hidden" name="PBX_RANG" value="' + formData.PBX_RANG + '">');
    document.write('<input type="hidden" name="PBX_IDENTIFIANT" value="' + formData.PBX_IDENTIFIANT + '">');
    document.write('<input type="hidden" name="PBX_TOTAL" value="' + formData.PBX_TOTAL + '">');
    document.write('<input type="hidden" name="PBX_DEVISE" value="' + formData.PBX_DEVISE + '">');
    document.write('<input type="hidden" name="PBX_CMD" value="' + formData.PBX_CMD + '">');
    document.write('<input type="hidden" name="PBX_PORTEUR" value="' + formData.PBX_PORTEUR + '">');
    document.write('<input type="hidden" name="PBX_RETOUR" value="' + formData.PBX_RETOUR + '">');
    document.write('<input type="hidden" name="PBX_HASH" value="' + formData.PBX_HASH + '">');
    document.write('<input type="hidden" name="PBX_TIME" value="' + formData.PBX_TIME + '">');
    document.write('<input type="hidden" name="PBX_HMAC" value="' + formData.PBX_HMAC + '">');
    document.write('</form>');

    let formValue = (<HTMLFormElement>document.getElementById('pbxForm'));
    setTimeout(formValue.submit(), 1000);
  }



}



// WEBPACK FOOTER //
// ./src/app/user/_payment/payment.component.ts